export default {
    overtimeRequest: 'คำขอ OT',
    close: 'ปิด',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    approve: 'อนุมัติ',
    reject: 'ไม่อนุมัติ',
    profile: 'ประวัติ',
    name: 'ชื่อ',
    employeeNo: 'รหัสพนักงาน',
    group: 'กลุ่ม',
    department: 'แผนก',
    requestStatus: 'สถานะคำขอ',
    contact: 'ติดต่อ',
    email: 'อีเมล์',
    phoneNumber: 'เบอร์โทร',
    dateOfOvertimeWork: 'วันที่ของ OT',
    timeOfOvertimeWork: 'เวลาของ OT',
    reason: 'เหตุผล',
    headDepartmentApproval: 'ผลพิจารณาโดยหัวหน้า',
    adminApproval: 'ผลพิจารณาโดยผู้ดูแลระบบ',
    congratulation: 'ยินดีด้วย',
    errorMessage: 'เกิดข้อผิดพลาด',
    otRequestCannotApprove: 'คำขอ OT นี้ไม่สามารถอนุมัติได้เนื่องจาก',
    otExisted: 'คาบเกี่ยวกับคำขอ OT ของวันที่',
    otOverlap: 'คาบเกี่ยวกับคำขอ OT อื่น',
    specialWorkdayOverlap: 'คาบเกี่ยวกับวันทำงานพิเศษ',
    timeTableOverlap: 'คาบเกี่ยวกับตารางเวลา',
    pastTimeTableOverlap: 'คาบเกี่ยวกับตารางเวลาที่ผ่านมา'
}
